import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({});
i18n.locale = localStorage.getItem('preferredLocale') || 'cs';
i18n.setLocaleMessage('cs', require('@resources/cs.json'));
i18n.setLocaleMessage('en', require('@resources/en.json'));

export default i18n;
